<template>
    <div>
        <my-search @search="searchHandler" v-model="pgData" title-placeholder="文件名称/文件编号">
            <el-form-item slot="time"></el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="addHandler('wj')" v-if="type=='wj'">
                    {{(formData.model.ext3 == 2 && formData.model.ext3childtype == 1) ? '添加征集文件' : '添加招标文件'}}
                </el-button>
                <el-button type="success" icon="el-icon-plus" @click="addHandler('cq')" v-if="type=='cq'">添加澄清文件</el-button>
                <el-button type="success" icon="el-icon-plus" @click="addHandler('bys')" v-if="type=='cq'">添加补遗书</el-button>
            </template>
        </my-search>

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="文件名称" prop="zbfilename" min-width="180" fixed="left"></el-table-column>
            <el-table-column label="文件编码" min-width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.cqwjbj==='0'&&isXt!='1'">
                        {{scope.row.by5}}
                    </span>
                    <span v-else>
                        {{scope.row.zbfilecode}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="所属类别（按类报名）" prop="categorycode" width="120" v-if="jtalbm"></el-table-column>
            <el-table-column label="投标有效期(天)" prop="tbyxq" width="140"></el-table-column>
            <el-table-column label="答疑澄清时间" prop="dycqtime" min-width="120" v-if="type=='cq'"></el-table-column>
            <el-table-column label="投标文件递交截止时间(开标时间)" prop="tbwjdjjztime" width="240"></el-table-column>
            <el-table-column label="投标文件解密截止时间" prop="tbwjjmjzsj" width="180"></el-table-column>
            <el-table-column label="质疑截止时间" prop="questionendday" width="180"></el-table-column>
            <el-table-column label="交易中心" min-width="160">
                <template slot-scope="scope">
                    <template v-if="type=='wj'">
                        <template v-if="scope.row.processflag=='1'">
                            <jyzx-state 
                                v-if="type=='cq'||type=='wj'"
                                :data="scope.row">
                            </jyzx-state>

                            <span v-if="type=='ycq'"></span>
                        </template>
                        <template v-else>
                            <template v-if="scope.row.shbj=='1'">

                                <template v-if="scope.row.by3=='1'||scope.row.by3=='2'">

                                    <template v-if="scope.row.xtts=='1'">
                                        <my-tag type="success">{{scope.row.by4}}--已推送</my-tag>
                                    </template>
                                    <template v-else>
                                        <my-tag type="warning">{{scope.row.by4}}--待推送</my-tag>
                                    </template>

                                </template>

                                <template v-else>
                                    <my-tag type="primary">{{scope.row.by4}}--无需推送</my-tag>
                                </template>

                            </template>

                        </template>
                    </template>
                    <template v-else-if="type=='cq'">
                        <template v-if="scope.row.shbj=='1'">

                            <template v-if="scope.row.by3=='1'||scope.row.by3=='2'">
                            
                                <template v-if="scope.row.xtts==1">
                                    <my-tag 
                                        v-if="scope.row.wjlx=='jyzxycq'||scope.row.wjlx=='jyzxcq'"
                                        type="primary">
                                            {{scope.row.by4}}--交易中心待审核
                                    </my-tag>
                                    <my-tag 
                                        v-else
                                        type="success">
                                            {{scope.row.by4}}--已推送
                                    </my-tag>
                                </template>
                                <template v-else>
                                    <my-tag 
                                        v-if="scope.row.wjlx=='jyzxycq'||scope.row.wjlx=='jyzxcq'||formData.model.ext5=='J13058201'"
                                        type="warning">
                                            {{scope.row.by4}}--待推送
                                    </my-tag>
                                    <my-tag 
                                        v-else
                                        type="primary">
                                            {{scope.row.by4}}--无需推送
                                    </my-tag>
                                </template>
                            </template>

                            <template v-else>
                                <my-tag type="primary">
                                    {{scope.row.by4}}--无需推送
                                </my-tag>
                            </template>

                        </template>
                    </template>

                    <template v-else>
                        <my-tag type="primary">
                            {{scope.row.jyzxname}}
                        </my-tag>
                    </template>
                    <push-type 
                        v-if="scope.row.by3=='1'"
                        :column="scope.row" 
                        :pushPage="tuisongType" 
                        :primaryKey="scope.row.zbfilecode"
                        :procode="getQuery('procode')">
                    </push-type>
                </template>
            </el-table-column>

            <el-table-column label="操作" min-width="180" fixed="right">
                <template slot-scope="scope">
                    <template 
                        v-if="scope.row.wjlx==='ycq'">
                        <template v-if="scope.row.shbj=='1'">
                            <div>
                                <my-tag type="warning">该文件尚未生效，请等待招管通备案通过</my-tag>
                            </div>
                            <el-button
                                @click="getshdw(scope.row)"
                                icon="el-icon-search"
                                type="text">
                                    查询审核状态
                            </el-button>
                        </template>
                        <template v-else-if="scope.row.shbj=='3'">
                            <div>
                                <my-tag
                                    type="danger">
                                        退回意见:{{scope.row.shyj}}
                                </my-tag>
                            </div>
                            
                            <el-button 
                                icon="el-icon-delete"
                                type="text" 
                                @click="del(scope.row.zbfilecode,scope.row.bmlx)">
                                    删除
                            </el-button>
                            
                            <my-btn 
                                type="edit" 
                                @click="editBys(scope.row.zbfilecode,scope.row.bmlx)"
                                v-if="scope.row.cqwjbj=='0'&&isXt=='1'">
                                    修改
                            </my-btn>
                        </template>
                        <template v-else>
                            <el-button 
                                icon="el-icon-delete"
                                type="text" 
                                @click="del(scope.row.zbfilecode,scope.row.bmlx)">
                                    删除
                            </el-button>
                            <my-btn 
                                v-if="scope.row.cqwjbj=='0'"
                                @click="editBys(scope.row.zbfilecode,scope.row.bmlx)"
                                type="edit">
                                    修改
                            </my-btn>
                        </template>
                    </template>

                    <template 
                        v-else-if="scope.row.wjlx == 'zbbycq'||scope.row.wjlx == 'zbbcq'||scope.row.wjlx =='zbbwj'">

                        <div v-if="scope.row.shbj=='1'">
                            <my-tag type="warning">该文件尚未生效，请等待招标办审核</my-tag>
                        </div>

                        <template v-if="scope.row.shbj!='1'&&scope.row.shbj!='3'">
                            <el-button 
                                icon="el-icon-delete"
                                type="text" 
                                @click="del(scope.row.zbfilecode)">
                                    删除
                            </el-button>
                            <my-btn 
                                v-if="scope.row.cqwjbj=='0'"
                                @click="editBys(scope.row.zbfilecode,scope.row.bmlx)"
                                type="edit">
                                    修改
                            </my-btn>
                        </template>

                    </template>

                    <template v-else>
                        <my-btn
                            v-if="scope.row.shbj!=='0'&&scope.row.shbj!=='3'"
                            @click="detail(scope.row)"
                            type="detail">
                                详情
                        </my-btn>
                        <template 
                            v-if="scope.row.shbj==='1'">
                            
                            <template>
                                <template v-if="!(formData.iszj||formData.anonymous)&&(formData.model.extsfbaomi=='0'||(scope.row.iskb&&formData.model.extsfbaomi=='1'))">
                                    <el-button
                                        v-if="scope.row.cqwjbj!='0'"
                                        icon="el-icon-download"
                                        @click="xzjl(scope.row,formData.procode)"
                                        type="text">
                                            下载记录
                                    </el-button>

                                    <el-button
                                        v-if="type=='cq'"
                                        icon="el-icon-printer"
                                        @click="hzlist(scope.row,formData.procode)"
                                        type="text">
                                            已回执单位
                                    </el-button>
                                </template>

                            </template>
                            
                            
                            
                            <div v-if="formData.iszj&&formData.model.extzsfs=='资格预审'&&scope.row.zgtshbj!='9'&&formData.zgys!='1'&&isXt!=1&&scope.row.by3!='1'">
                                <my-tag type="warning">该文件尚未生效，请等待招管通备案通过</my-tag>
                                <el-button
                                    @click="getshdw(scope.row)"
                                    icon="el-icon-search"
                                    type="text">
                                        查询审核状态
                                </el-button>
                            </div>
                        </template>

                        <template v-else>
                            <div>
                                <my-tag 
                                    v-if="scope.row.shbj=='3'"
                                    type="danger">
                                        退回意见:{{scope.row.shyj}}
                                </my-tag>
                            </div>
                            <el-button 
                                icon="el-icon-delete"
                                type="text" 
                                @click="del(scope.row.zbfilecode,scope.row.bmlx)">
                                    删除
                            </el-button>
                            <my-btn 
                                v-if="scope.row.wjlx.indexOf('cq')!=-1&&scope.row.cqwjbj=='0'"
                                @click="editBys(scope.row.zbfilecode,scope.row.bmlx)"
                                type="edit">
                                    修改
                            </my-btn>
                        </template>
                    </template>
                    
                </template>
            </el-table-column>
        </my-table>

        <my-pagination 
            ref="page" 
            :after-query="firstData" 
            v-model="tableData" 
            :search="pgData" 
            :action="`${getGetters('mngUrl')}/FaBiao/ZbFile/`+processType+type+`/get_list.json`">
        </my-pagination>

        <!-- 弹窗 -->
        <my-dialog 
            v-model="dialogVisible" 
            :width="dialogwidth" 
            :title="dialogTitle">
                <component 
                    v-if="dialogVisible" 
                    :is="dialogComponent" 
                    :data="dialogData" 
                    @cancle="dialogClose">
                </component>
        </my-dialog>
       
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

import BTN_CONF from './config/btn-list'
import STATE_CONF from './config/state'

import JyzxState from '@views/bidding/components/jyzx-state'
import PushType from '@/components-sys/push-type'


export default {
    mixins: [LIST_PAGE_MIXIN,DIALOG_LIST_PAGE_MIXIN],
    components:{
        xzjlList: () => import('./dialog/xzjlList'),
        formTbzt: () => import('./dialog/form-tbzt'),
        hzList: () => import('./dialog/hzList'),
        PushType,JyzxState
    },
    data() {
        return{
            pgData: {
                zgys:this.getQuery('zgys')||'',
                sortname:'addtime',
                procode:this.getQuery('procode'),
            },
            type:'',
            tuisongType:'',
            BTN_CONF,
            STATE_CONF,

            formData:{},

            // dialog
            dialogComponent: '',
            dialogData: {},
            dialogTitle: '',
            dialogwidth:'893px',

            isXt:'',
            processType:'',
            jtalbm:true,
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //加载列表结束
        firstData(table){
            var that = this
            table.forEach(function (item){
                if(item.zbfilecode!=null&&item.zbfilecode!=""){
                    $.get(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.type+`/iskb.json`, {
                        zbfilecode:item.zbfilecode,
                        t:Math.random(),
                    }, data => {
                        item.iskb = data.result
                    });
                }
            })
            
        },
        // 删除
        del(id,bmlx){
            var that = this
            if(bmlx=='1'){
                that.$confirm('【按类报名】项目，招标文件删除时，同一类所属标段数据会同步删除，确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    callback:function (value,instance) {
                        if(value=='confirm'){
                            that.$post(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.processType+that.type+`/relation/del.json`, {
                                id:id,
                                oper:'del'
                            }, data => {
                                ShowMsg('删除成功','success')
                                that.reloadHandler();
                            });
                        }

                    }
                });
            }else{
                that.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    callback:function (value,instance) {
                        if(value=='confirm'){
                            that.$post(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.processType+that.type+`/del.json`, {
                                id:id,
                                oper:'del'
                            }, data => {
                                ShowMsg('删除成功','success')
                                that.reloadHandler();
                            });
                        }

                    }
                });
            }
                
           
        },
        // 修改
        gotobysEdit(id){
            this.goto({
                path:'/bidding/projectflow/fabiao/zbFile/bysForm',
                query:{
                    id:id,
                    procode:this.formData.procode,
                    isXt:this.isXt,
                }
            });
        },
        // 判断是否按类报名
        editBys(id,bmlx){
            var that = this
            if(bmlx=='1'){
                that.$confirm('【按类报名】项目，进行数据修改时，同一类所属标段相关数据会同步修改，确定修改吗？', '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    type: 'warning',
                    callback:function (value,instance) {
                        if(value=='confirm'){
                            that.gotobysEdit(id)
                        }
                    }
                })
            }else{
                that.gotobysEdit(id)
            }
            
        },
        // 详情
        detail(obj){
            if(this.type==='cq'&&obj.cqwjbj==='0'){
                this.goto({
                    path:'/bidding/projectflow/fabiao/zbFile/bysdetail',
                    query:{
                        id:obj.zbfilecode,
                        forbidjump:this.formData.forbidjump,
                        isXt:this.isXt,
                        zjwj:(this.formData.model.ext3 == 2 && this.formData.model.ext3childtype == 1) ? true : false
                    }
                });
            }else{
                this.goto({
                    path:'/bidding/projectflow/fabiao/zbFile/detail',
                    query:{
                        id:obj.zbfilecode,
                        procode:this.formData.procode,
                        forbidjump:this.formData.forbidjump,
                        zgys:this.formData.zgys,
                        pageType:this.type,
                        isXt:this.isXt,
                        zjwj:(this.formData.model.ext3 == 2 && this.formData.model.ext3childtype == 1) ? true : false
                    }
                });
            }
        },
        // 下载记录
        xzjl(row,procode){
            var zbfilecode = row.zbfilecode
            if(this.isXt=='1'){
                zbfilecode = row.newzbfilecode
            }
            this.dialogData = {
                id: zbfilecode,
                procode: procode
            };
            this.dialogTitle = '文件下载记录'
            this.dialogComponent = 'xzjlList';
            this.dialogwidth = '1200px'
            this.dialogShow();
        },
        // 已回执单位列表
        hzlist(row,procode){
            var zbfilecode = row.zbfilecode
            if(this.isXt=='1'){
                zbfilecode = row.newzbfilecode
            }
            this.dialogData = {
                id: zbfilecode,
                procode: procode,
                isXt:this.isXt,
            };
            this.dialogTitle = '已回执单位'
            this.dialogComponent = 'hzList';
            this.dialogShow();
        },
        // 添加页面
        addHandler(val){
            if(val=='wj'){
                // 添加招标文件
                this.goto({
                    path:'/bidding/projectflow/fabiao/zbFile/form',
                    query:{
                        procode:this.formData.procode,
                        forbidjump:this.formData.forbidjump,
                        zgys:this.formData.zgys,
                        pageType:this.type,
                        isXt:this.isXt,
                        zgys:this.getQuery('zgys')||''
                    }
                });
            }else if(val=='cq'){
                // 添加澄清文件
                this.goto({
                    path:'/bidding/projectflow/fabiao/zbFile/form',
                    query:{
                        procode:this.formData.procode,
                        forbidjump:this.formData.forbidjump,
                        pageType:this.type,
                        isXt:this.isXt,
                        zgys:this.getQuery('zgys')||''
                    }
                });
            }else{
                // 添加补遗书
                this.goto({
                    path:'/bidding/projectflow/fabiao/zbFile/bysForm',
                    query:{
                        procode:this.formData.procode,
                        isXt:this.isXt,
                    }
                });
            }
            
        },
        //查询招管通备案审核
        getshdw(row){
            var zbfilecode = '';
            if(this.isXt!='1'){
                if(row.cqwjbj=='0'){
                    zbfilecode = row.by5;
                }else{
                    zbfilecode = row.zbfilecode;
                }
            }else{
                zbfilecode = row.newzbfilecode;
            }
            
            this.dialogData = {
                zbfilecode: zbfilecode,
                type: this.type,
                isXt: this.isXt
            };
            this.dialogTitle = '审核状态'
            this.dialogComponent = 'formTbzt';
            this.dialogShow();
        }
    },
    created() {
        var that = this
        if(that.getQuery('pageType')=='1'){
            that.type="cq";
            that.tuisongType = 'dycq';
        }else{
            that.type="wj";
            that.tuisongType = 'zbwj';
        }
        // 判断是否邢台项目
        if(that.getQuery('isXt')=='1'){
            that.isXt = that.getQuery('isXt')
            that.processType = 'xingtai/'
        }

        that.jspInit(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.processType+that.type+`/list.json`, {
            procode:that.getQuery('procode'),
            zgys:that.getQuery('zgys'),
        }, data => {
            that.formData = data
            console.log(that.formData)
            if(!that.formData.jtalbm){
                that.jtalbm = false
            }
        });
        

    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>

 